<template>
  <section class="table-sampler-result-chemical">
    <d-list-group flush>
      <d-list-group-item class="d-flex px-3 py-4" v-for="(result, index) in model" v-bind:key="index">
        <d-col class="col px-0">
          <d-form-row class="m-0 mb-1">
            <d-col cols="1">
              <label>Código</label>
              <input
                type="text"
                class="form-control"
                placeholder="Código"
                v-model="result.code"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Agente quimico</label>
              <input
                type="text"
                class="form-control"
                placeholder="Agente quimico"
                v-model="result.agent_chemical"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Método</label>
              <input
                type="text"
                class="form-control"
                placeholder="Método"
                v-model="result.method"
                required
              />
            </d-col>
            <d-col cols="1">
              <label>LQ</label>
              <select type="text" class="form-control" v-model="result.lq" required>
                <option value="Abaixo">Abaixo</option>
                <option value="A cima">A cima</option>
              </select>
            </d-col>
            <d-col cols>
              <label>Resultado</label>
              <input
                type="text"
                class="form-control"
                placeholder="Resultado"
                v-model="result.result"
                @input="updateConclusion(index)"
                required
              />
            </d-col>
            <d-col cols="1">
              <label>Unidade</label>
              <select type="text" class="form-control" v-model="result.unity" required>
                <option value="ppm">ppm</option>
                <option value="mg/m³">mg/m³</option>
              </select>
            </d-col>
            <d-col cols>
              <label>TWA <small>(ACGIH)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Twa"
                v-model="result.twa"
                @input="updateConclusion(index)"
                required
              />
            </d-col>
            <d-col cols>
              <label>NR-15</label>
              <input
                type="text"
                class="form-control"
                placeholder="NR-15"
                v-model="result.mp"
                @input="updateConclusion(index)"
                required
              />
            </d-col>
            <d-col cols>
              <label>Base cálculo</label>
              <select
                type="text"
                class="form-control"
                v-model="result.calculation_base"
                @change="updateConclusion(index)"
                required
              >
                <option value="TWA">TWA</option>
                <option value="NR-15">NR-15</option>
              </select>
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="3">
              <label>Celling <small>(ACGIH)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Celling"
                v-model="result.celling"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Teto <small>(NR 15)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Teto"
                v-model="result.teto"
                required
              />
            </d-col>
            <d-col cols="3">
              <label>Tamanho aerodispersóides</label>
              <select
                type="text"
                class="form-control"
                v-model="result.size_aerodispersoides"
                required
              >
                <option value="Total">Total</option>
                <option value="Toraxico">Toraxico</option>
                <option value="Respirável">Respirável</option>
                <option value="Inalável">Inalável</option>
                <option value="n.a.">N.A.</option>
              </select>
            </d-col>
            <d-col cols>
              <label>STEL <small>(ACGIH)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Stel"
                v-model="result.stel"
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="6">
              <label>Ação no Organismo</label>
              <input
                type="text"
                class="form-control"
                placeholder="Ação no Organismo"
                v-model="result.action_in_body"
                required
              />
            </d-col>
            <d-col cols="6">
              <label>Notação pele</label>
              <input
                type="text"
                class="form-control"
                placeholder="Notação pele"
                v-model="result.notion_skin"
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="2">
              <label>Fator desvio <small>(NR 15)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Fator desvio"
                v-model="result.deviation_factor"
                required
              />
            </d-col>
            <d-col cols="4">
              <label>OSHA - IR</label>
              <input
                type="text"
                class="form-control"
                placeholder="OSHA - IR"
                v-model="result.osha"
                required
              />
            </d-col>
            <d-col cols="6">
              <label>Meio de dispersão</label>
              <input
                type="text"
                class="form-control"
                placeholder="Meio de dispersão"
                v-model="result.dispersal"
                required
              />
            </d-col>
          </d-form-row>
          <d-form-row class="m-0 mb-1">
            <d-col cols="2">
              <label>IPVS <small>(PPM)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="IPVS"
                v-model="result.ipvs"
                required
              />
            </d-col>
            <d-col cols="2">
              <label>Limite de odor <small>(PPM)</small></label>
              <input
                type="text"
                class="form-control"
                placeholder="Limite de odor"
                v-model="result.odor_limit"
                required
              />
            </d-col>
            <d-col cols="4">
              <label>Respirador recomendado</label>
              <input
                type="text"
                class="form-control"
                placeholder="Respirador recomendado"
                v-model="result.respirator"
                required
              />
            </d-col>
            <d-col cols="4">
              <label>Conclusão</label>
              <input
                type="text"
                class="form-control"
                placeholder="Conclusão"
                v-model="result.conclusion"
                required
              />
            </d-col>
          </d-form-row>
        </d-col>
        <d-col class="col-controls flex align-content-center justify-content-center px-0">
          <div class="icon-controls flex justify-content-center">
            <i class="fas cursor-pointer fa-plus text-success" @click="addRow()" v-if="index + 1 === model.length"></i>
            <i class="fas cursor-pointer fa-minus text-danger" @click="removeRow(index)"></i>
          </div>
        </d-col>
      </d-list-group-item>
    </d-list-group>
  </section>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import { CHEMICAL } from '_modules/settings/components/SettingsModel';
import { CHEMICAL_RESULT, _LOAD_MODEL_ } from '../../SampleModel';

export default {
  name: 'Sample-Result-Chemical',
  props: {
    result: {
      type: Array || Object,
      default: null,
    },
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    chemicalSettings() {
      const { chemicalResult } = this.$store.state.settings;
      if (chemicalResult) {
        return chemicalResult;
      }
      return { ...CHEMICAL };
    },
  },
  methods: {
    ...mapActions([
      'getSettings',
    ]),
    setModel() {
      if (this.result && Array.isArray(this.result) && this.result.length > 0) {
        this.model = cloneDeep(this.result);
        this.model.forEach((_, index) => this.updateConclusion(index));
      } else {
        this.model = [cloneDeep(CHEMICAL_RESULT)];
      }
    },
    addRow() {
      const newResult = cloneDeep(CHEMICAL_RESULT);
      this.model.push(newResult);
    },
    removeRow(index) {
      this.model.splice(index, 1);
      if (this.model.length === 0) {
        this.addRow();
      }
    },
    updateConclusion(index) {
      const response = this.calculateConclusion(this.model[index]);
      this.model[index].conclusion = response.conclusion;
      this.model[index].bg_color = response.bgColor;
      this.model[index].risk_level = response.riskLevel;
    },
    calculateConclusion(item) {
      const result = this.convertToNumber(item.result);
      const conclusionDefault = { conclusion: '---', bgColor: '#cfcfc4', riskLevel: '---' };

      if (item.calculation_base === undefined || result === null) {
        return conclusionDefault;
      }
      if (item.calculation_base === 'TWA') {
        const twa = this.convertToNumber(item.twa);

        if (twa) {
          return this.getRiskConclusion(result / twa);
        }
      } else {
        const nr15 = this.convertToNumber(item.mp);

        if (nr15) {
          return this.getRiskConclusion(result / nr15);
        }
      }
      return conclusionDefault;
    },
    convertToNumber(value) {
      if (value) {
        const number = parseFloat(value.toString().replace(/,/g, '.'));
        if (!Number.isNaN(number) && number !== 0) {
          return number;
        }
      }
      return null;
    },
    validateRiskValues() {
      const riskKeys = ['lowRisk', 'mediumRisk1', 'mediumRisk2', 'highRisk'];

      riskKeys.forEach(key => {
        if (this.chemicalSettings[key] && typeof this.chemicalSettings[key] === 'string') {
          this.chemicalSettings[key] = this.convertToNumber(this.chemicalSettings[key]);
        }
      });
    },
    getRiskConclusion(divisionResult) {
      this.validateRiskValues();

      const {
        lowRisk,
        mediumRisk1,
        mediumRisk2,
      } = this.chemicalSettings;

      if (divisionResult < lowRisk) {
        return {
          conclusion: this.chemicalSettings.lowRiskConclusion,
          bgColor: this.chemicalSettings.lowRiskColor,
          riskLevel: 'lowRisk',
        };
      }
      if (divisionResult >= mediumRisk1 && divisionResult <= mediumRisk2) {
        return {
          conclusion: this.chemicalSettings.mediumRiskConclusion,
          bgColor: this.chemicalSettings.mediumRiskColor,
          riskLevel: 'mediumRisk',
        };
      }
      return {
        conclusion: this.chemicalSettings.highRiskConclusion,
        bgColor: this.chemicalSettings.highRiskColor,
        riskLevel: 'highRisk',
      };
    },
  },
  mounted() {
    this.getSettings()
      .then(() => this.setModel());
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
  },
  watch: {
    model: {
      handler(value) {
        this.$emit('update:result', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-result-chemical {
  margin-inline: -15px;
  .col-controls {
    max-width: 50px;
    .icon-controls {
      display: flex;
      gap: 10px;
      .fas {
        cursor: pointer;
      }
    }
  }
}
</style>
